<template>
  <v-container fluid fill-height>
    <v-row class="d-flex justify-center my-0 py-0">
      <v-col cols="9" xl="7" lg="7" md="7" sm="7">
        <v-autocomplete
          v-model="statusSelected"
          dense
          hide-details=""
          @change="selectionChanged"
          :items="status"
          item-text="name"
          :label="translations.label_status"
          background-color="white"
          outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-btn
          :loading="loading"
          color="success"
          small
          @click="filters = !filters"
        >
          <v-icon v-if="filters"> mdi-filter-minus </v-icon>
          <v-icon v-else> mdi-filter-menu </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center my-0 py-0" v-if="filters">
      <v-col cols="10">
        <v-expand-transition>
          <v-row class="mt-0 mb-2">
            <v-card elevation="3" width="100%" flat class="rounded-lg">
              <v-card-title class="py-2 text-subtitle-1"
                >{{ translations.label_advanced_filters }}
                <v-spacer></v-spacer>
                <v-btn
                  small
                  color="orange"
                  class="mr-2"
                  dark
                  @click="deleteFilters"
                >
                  <v-icon> mdi-filter-off </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-container>
                  <v-row class="px-4 py-0">
                    <v-text-field
                      :error="errorInput"
                      :error-messages="errorMessages"
                      v-model="nameProfit"
                      class="py-0"
                      :label="translations.label_name_or_code_profitability"
                      prepend-icon="mdi-card-text"
                      :loading="loading"
                    ></v-text-field>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-row>
        </v-expand-transition>
      </v-col>
    </v-row>
    <v-row v-if="loading">
      <v-col cols="12" v-for="item in 6" :key="item" class="py-2">
        <v-skeleton-loader
          type="list-item-av
        atar-three-line"
        />
      </v-col>
    </v-row>
    <v-row v-else class="mb-5">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="4"
        sm="6"
        xs="12"
        v-for="profit in profits"
        :key="profit.id"
        no-gutters
        class="py-2"
      >
        <ProfitItem :profit="profit" />
      </v-col>
    </v-row>
    <div class="overlayCenter" v-if="!loading && profits.length <= 0">
      <p class="text-center">{{ translations.label_no_profitability }}</p>
    </div>
    <!-- copyright -->
    <v-footer class="text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </v-container>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
//Components
import ProfitItem from "@/components/territory/ProfitItem.vue";
export default {
  components: {
    ProfitItem,
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
  },
  data: () => ({
    isMoreData: true,
    errorInput: false,
    errorMessages: "",
    loading: false,
    nameProfit: "",
    code: "",
    profits: [],
    page: 0,
    organizationId: "",
    filters: false,
    statusSelected: null,
    busyGettingData: false,
    status: [],
  }),
  created() {
    this.status = [
      { name: this.translations.status_profits["ALL"], value: "ALL" },
      { name: this.translations.status_profits["NEW"], value: "NEW" },
      { name: this.translations.status_profits["PROPOSAL"], value: "PROPOSAL" },
      { name: this.translations.status_profits["ACCEPTED"], value: "ACCEPTED" },
      { name: this.translations.status_profits["FINISHED"], value: "FINISHED" },
    ];
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapActions("profit", ["getProfits", "getProfitFiltered"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    goBack() {
      this.$router.push(`/seller-list/client/`);
    },
    async selectionChanged() {
      this.isMoreData = true;
      this.page = 0;
      this.profits = [];
      let user = JSON.parse(localStorage.getItem("user"));
      if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
        this.organizationId = localStorage.getItem("organizationId");
      } else {
        this.organizationId = localStorage.getItem("clientId");
      }
      if (this.nameProfit.length > 0) {
        let response = await this.getProfitFiltered({
          clientId: this.organizationId,
          page: this.page,
          status: this.statusSelected,
          name: this.nameProfit,
        });

        if (response) {
          if (!response.error) {
            if (response.protocols.length > 0) {
              this.profits = response.protocols;
              this.page++;
            } else {
              this.isMoreData = false;
            }
          } else {
            console.log(response.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } else {
        let response = await this.getProfitFiltered({
          clientId: this.organizationId,
          page: this.page,
          status: this.statusSelected,
        });

        if (response) {
          if (!response.error) {
            if (response.protocols.length > 0) {
              this.profits = response.protocols;
              this.page++;
            } else {
              this.isMoreData = false;
            }
          } else {
            console.log(response.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      }
    },
    async deleteFilters() {
      this.nameProfit = "";
    },
    async handleScroll() {
      try {
        if (
          window.scrollY + window.innerHeight >=
          document.body.scrollHeight - 50
        ) {
          let user = JSON.parse(localStorage.getItem("user"));
          if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
            this.organizationId = localStorage.getItem("organizationId");
          } else {
            this.organizationId = localStorage.getItem("clientId");
          }
          if (this.busyGettingData) return;
          if (this.isMoreData) {
            if (this.nameProfit.length > 0) {
              this.busyGettingData = true;
              let response = await this.getProfitFiltered({
                clientId: this.organizationId,
                page: this.page,
                status: this.statusSelected,
                name: this.nameProfit,
              });

              if (response) {
                if (!response.error) {
                  if (response.protocols.length > 0) {
                    this.profits.push(...response.protocols);
                    this.page++;
                  } else {
                    this.isMoreData = false;
                  }
                } else {
                  console.log(response.message);
                  this.SET_ALERT_TYPE({
                    visible: true,
                    type: "error",
                    text: this.translations.advice_error,
                    timeout: 4000,
                  });
                }
              } else {
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.advice_error,
                  timeout: 4000,
                });
              }
            } else {
              this.busyGettingData = true;
              let response = await this.getProfitFiltered({
                clientId: this.organizationId,
                page: this.page,
                status: this.statusSelected,
              });

              if (response) {
                if (!response.error) {
                  if (response.protocols.length > 0) {
                    this.profits.push(...response.protocols);
                    this.page++;
                  } else {
                    this.isMoreData = false;
                  }
                } else {
                  console.log(response.message);
                  this.SET_ALERT_TYPE({
                    visible: true,
                    type: "error",
                    text: this.translations.advice_error,
                    timeout: 4000,
                  });
                }
              } else {
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.advice_error,
                  timeout: 4000,
                });
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    try {
      let user = JSON.parse(localStorage.getItem("user"));
      if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
        if (user.role == "ORG_USER_ADMIN") {
          this.organizationId = localStorage.getItem("organizationId");
          this.SET_APPBAR_OPTIONS({
            leftButton: "menu",
            // rightButton: "profit_add",
          });
        } else {
          this.organizationId = localStorage.getItem("organizationId");
          this.SET_APPBAR_OPTIONS({
            leftButton: "menu",
          });
        }
      } else {
        this.organizationId = localStorage.getItem("clientId");
        this.SET_APPBAR_OPTIONS({
          leftButton: "menu_seller",
          // rightButton: "profit_add",
          funcLeftButton: this.goBack,
        });
      }
      this.statusSelected = "ALL";
      let response = await this.getProfitFiltered({
        clientId: this.organizationId,
        page: this.page,
        status: this.statusSelected,
      });
      if (response) {
        if (!response.error) {
          this.profits = response.protocols;
          this.page++;
        } else {
          console.log(response.message);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } else {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        text: this.translations.advice_error,
        timeout: 4000,
      });
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    async nameProfit() {
      await this.selectionChanged();
    },
  },
};
</script>

<style scoped>
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}
</style>
